export default __webpack_public_path__ + "static/media/ProximaNova-Light.f70705f2.ttf";